import React from "react"

import { withRunEventLabelState } from "../../../../../components/shared_components_registration"
import { ColorBoxWithLabel } from "../../GraphComponents/CrossHairLayer/PointDataOverlay"

const RunEventLabelLegend = ({ runEventLabels = [], runEventRegistration = [] }) => {
  const uniqueEvents = [...new Set(runEventLabels.map((l) => l.event_type))]
  const validRunEvents = runEventRegistration.filter((e) => uniqueEvents.includes(e.name) && e.show)
  if (runEventLabels.length === 0 || validRunEvents.length === 0) return <></>

  return (
    <div style={{ marginTop: "5px" }} align="center">
      <label>Run Event Labels:</label>
      &nbsp;
      {validRunEvents.map((e) => {
        return (
          <React.Fragment key={e.name}>
            <ColorBoxWithLabel color={e.default_color} opacity={e.opacity} text={e.name} />
            &nbsp;
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default withRunEventLabelState(RunEventLabelLegend)
